"use client";

import { useHydrated } from "@frend-digital/ui/hooks";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface RecentlyViewedStore {
  productIds: string[];
  addProductId: (product: string) => void;
  clear: () => void;
}

const useInitialRecentlyViewed = create(
  persist<RecentlyViewedStore>(
    (set, get) => ({
      productIds: [],
      addProductId: product => {
        const productIds = get().productIds;
        const filteredIds = Array.from(
          new Set(productIds.filter(id => id !== product)),
        );
        const newRecentlyViewed = [product, ...filteredIds].slice(0, 8);
        set({ productIds: newRecentlyViewed });
      },
      clear: () => {
        set({ productIds: [] });
      },
    }),
    {
      name: "recentlyViewedProductIds",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export const useRecentlyViewed = () => {
  const hydrated = useHydrated();
  const { productIds, addProductId, clear } = useInitialRecentlyViewed();

  return {
    productIds: hydrated ? productIds : [],
    addProductId,
    clear,
  };
};
